<div class="message-box" [ngStyle]="{ 'background-color': backgroundColor }">
  <div class="message-content">
    <span
      class="message-icon"
      [innerHTML]="safeSvgIcon"
      [ngStyle]="{ 'font-size': iconFontSize, color: iconColor }"
    ></span>
    <span class="message-text" [ngStyle]="{ color: messageColor }">{{
      message
    }}</span>
  </div>
</div>
